import React from 'react';
import { Accordion, Badge, Card, Col, Row } from 'react-bootstrap';
export default function ClaimerDataPreviewProjects(_ref) {
  let {
    aifReportData
  } = _ref;
  const {
    aif_model
  } = aifReportData;
  const formatCurrency = amount => {
    if (!amount) return '£0';
    const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(numAmount);
  };
  return /*#__PURE__*/React.createElement(Card, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Card.Header, {
    className: "bg-dark text-white"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "mb-0"
  }, "Projects (", aif_model.projects.total_projects, " total)")), /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Accordion, null, aif_model.projects.projects_described.map((project, index) => /*#__PURE__*/React.createElement(Accordion.Item, {
    eventKey: index.toString(),
    key: index
  }, /*#__PURE__*/React.createElement(Accordion.Header, null, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between w-100 me-3"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("strong", null, "Project ", project.number, ":"), " ", project.name), /*#__PURE__*/React.createElement(Badge, {
    bg: "primary"
  }, formatCurrency(project.amount)))), /*#__PURE__*/React.createElement(Accordion.Body, null, /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, "Rate Type:"), " ", /*#__PURE__*/React.createElement(Badge, {
    style: {
      backgroundColor: 'var(--bs-cyan) !important'
    }
  }, project.rate_type.toUpperCase())), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, "Field:"), " ", project.field?.replace(/_/g, ' ')), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, "Amount:"), " ", formatCurrency(project.amount)))), /*#__PURE__*/React.createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement("h6", {
    className: "text-primary"
  }, "Baseline Knowledge"), /*#__PURE__*/React.createElement("p", {
    className: "text-justify"
  }, project.baseline)), /*#__PURE__*/React.createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement("h6", {
    className: "text-primary"
  }, "Advance Sought"), /*#__PURE__*/React.createElement("p", {
    className: "text-justify"
  }, project.advance)), /*#__PURE__*/React.createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement("h6", {
    className: "text-primary"
  }, "Technical Challenges"), /*#__PURE__*/React.createElement("p", {
    className: "text-justify"
  }, project.technical_challenges)), /*#__PURE__*/React.createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement("h6", {
    className: "text-primary"
  }, "Work Done"), /*#__PURE__*/React.createElement("p", {
    className: "text-justify"
  }, project.work_done))))))));
}